<div class="platform-switcher">
  <div class="platform-switcher__icons">
    <div class="platform-switcher__logo">
      <tux-svg [src]="demandscienceLogoWhite"></tux-svg>
    </div>
    <div class="platform-switcher__caret">
      <fa-icon [icon]="faCaretDown"></fa-icon>
    </div>
  </div>
  <div
    [ngClass]="{
      'platform-switcher__ms-text': appName === 'Measurement Studio',
      'platform-switcher__text': appName !== 'Measurement Studio'
    }"
  >
    {{ appName }}
  </div>
</div>
